import { createShapeNormalizer } from '@change-corgi/fcm/normalizers';

import { defineFcm } from '../shared/factory';

export const FCM_PSF_QUESTIONNAIRE = defineFcm('psf_questionnaire')
	.asJson(
		createShapeNormalizer({
			type: 'object',
			shape: {
				isEnabled: { type: 'boolean' },
				questionnaireId: { type: 'string' },
				systemPrompt: { type: 'string' },
				questionnaireDefinition: {
					type: 'record',
					shape: {
						type: 'object',
						shape: {
							questions: {
								type: 'array',
								shape: {
									type: 'object',
									shape: {
										ref: { type: 'string' },
										type: {
											type: 'enum',
											values: ['multi_select', 'single_select', 'stance'] as const,
										},
										question: { type: 'string' },
										options: {
											type: 'array',
											shape: {
												type: 'object',
												shape: {
													ref: { type: 'string' },
													label: { type: 'string' },
												},
											},
										},
									},
								},
							},
						},
					},
				},
				options: {
					type: 'object',
					optional: true,
					shape: {
						model: { type: 'string', optional: true },
						temperature: { type: 'number', optional: true },
						max_completion_tokens: { type: 'number', optional: true },
					},
				},
			},
		}),
	)
	.withDefault({
		isEnabled: false,
		questionnaireId: '',
		systemPrompt: '',
		questionnaireDefinition: {},
		options: undefined,
	})
	.toConfig({
		owner: 'squad-chameleon',
		scope: 'corgi-middle-end',
		context: 'PSF questionnaire experiment',
		description:
			'LLM and questionnaire definition for the personalizedPetitionsByAnswers flow: systemPrompt, optional questionnaireDefinition JSON, and OpenAI options.',
		import: false,
		template: {
			isEnabled: false,
			questionnaireId: 'psf_onboarding',
			systemPrompt: 'Map questionnaire answers to petition search intents.',
			questionnaireDefinition: {
				v1: {
					questions: [
						{
							ref: 'interests',
							type: 'multi_select',
							question: 'Which issues do you care about?',
							options: [
								{ ref: 'climate', label: 'Climate and environment' },
								{ ref: 'healthcare', label: 'Healthcare access' },
							],
						},
					],
				},
			},
			options: {
				model: 'gpt-5.4-mini',
				temperature: 1,
				max_completion_tokens: 2048,
			},
		},
	});
